export default "__VITE_ASSET__B7B6zVEr__"